module.exports = __webpack_public_path__ + "img/icon_trade_new.4d4488be.png";